<template>
	<div class="index-box">
		<div class="goback" @click="link('https://www.dzwjcloud.com/')">
			<img src="../assets/goback.png" />
			返回主页
		</div>
		<div class="title">
			<span>工业互联网应用中心</span>
			<div class="hr"></div>
		</div>
		<div class="swiper-box">
			<div class="side-nav">
				<div class="box" :class="actives == index ? 'active' : ''" v-for="(item,index) in listData" :key="index" @click="navClick(index)">{{item.appname}}</div>
			</div>
			<div class="side-swiper">
				<swiper ref="sideSwiper" :options="swiperOptions" v-if="listData != ''">
					<swiper-slide v-for="(item, index) in listData" :key="index">
						<div class="box">
							<img :src="item.applogo ? $imgUrl + item.applogo : require('../assets/no-img-x.jpg')" :alt="item.appname" />
							<div class="em">
								<div class="h">{{ item.appname }}</div>
								<div class="text">{{ item.appdetail }}</div>
								<div class="btns"><a @click="contains(item.ssourl) ? openVisible(item) : link(item.ssourl + '?token=' + $url.access_token)">立即体验 >></a></div>
							</div>
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</div>
		<el-dialog
		  title="选择账套"
		  :visible.sync="ztVisible"
		  width="30%"
		  append-to-body>
		  <div class="epListBox">
			  <div class="list" v-for="(item,index) in epList" :key="index" @click="link(accUrl + item.cAcc_Num)">
				  {{item.cAcc_Name}}
			  </div>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'index',
	data() {
		return {
			swiperOptions: {},
			actives: 0,
			listData: [],
			ztVisible: false,
			epList: [],
			accUrl: ''
		};
	},
	computed: {
		swiper() {
			return this.$refs.sideSwiper.$swiper;
		}
	},
	mounted() {
		// this.swiper.slideTo(3, 1000, false);
		var that = this;
		this.getApp();
		this.swiperOptions = {
			direction: 'vertical',
			mousewheel: true,
			on: {
				slideChange: function() {
					that.actives = this.activeIndex;
				}
			}
		};
	},
	methods: {
		getApp: function() {
			this.$http({
				url: this.$url.getUserApplicationNoToken,
				method: 'post'
			}).then(res => {
				if (res.code === 200) {
					this.listData = res.rows;
				}
			});
		},
		navClick: function(val) {
			this.actives = val;
			this.swiper.slideTo(this.actives, 1000, false);
		},
		link: function(url) {
			this.ztVisible = false
			window.open(url);
		},
		contains: function(str) {
			return str.indexOf('view/portal/portal.html') != -1;
		},
		openVisible: function(item) {
			var that = this
			
			this.$http({
				url: this.$url.relevanceToken + this.$url.access_token,
				method: 'get',
			}).then(resp => {
				this.$http({
					url: this.$url.getInfo,
					method: 'get',
					headers: {
						'Authorization': 'Bearer ' + this.$url.access_token
					}
				}).then(res => {
					if (res.code === 200) {
						var accNum = res.cAcc_Num
						if (!accNum) {
							window.open(item.ssourl + '&user=13883996071&pwd='+ that.$md5('jg123456') +'&accNum='+accNum)
						} else {
							this.accUrl = item.ssourl + '&user=13883996071&pwd='+ that.$md5('jg123456') +'&accNum='
							this.epList = JSON.parse(accNum)
							if (this.epList.length == 1) {
								window.open(this.accUrl + this.epList[0].cAcc_Num)
							} else {
								this.ztVisible = true
							}
						}
					}
				})
			})
		}
	}
};
</script>

<style lang="scss" scoped>
	.epListBox{
		max-height: 500px;
		overflow: auto;
		.list{
			display: block;
			text-align: center;
			border: 1px solid #007bff;
			background: #fff;
			color: #333;
			padding: 10px 0;
			border-radius: 5px;
			margin-bottom: 10px;
			cursor: pointer;
			&:hover{
				background: #0072ff;
				color: #fff;
			}
		}
	}
.index-box {
	position: fixed;
	left: 0;
	top: 0;
	overflow: auto;
	width: 100%;
	height: 100%;
	background: url(../assets/bg.png) no-repeat center center / cover;
	.goback {
		display: flex;
		align-items: center;
		padding: 10px 20px;
		background: #1a76d1;
		color: #fff;
		position: absolute;
		left: 50px;
		top: 50px;
		z-index: 9;
		cursor: pointer;
		border-radius: 2px;
		img {
			margin-right: 10px;
		}
	}
	.title {
		font-size: 48px;
		color: #fff;
		margin-top: 100px;
		text-align: center;
		span {
			display: block;
			margin-bottom: 20px;
		}
		.hr {
			width: 120px;
			height: 4px;
			margin: 0 auto;
			background: #1a76d1;
		}
	}
	.swiper-box {
		display: flex;
		align-items: center;
		width: 80%;
		margin: 20px auto 0;
		.side-nav {
			border-left: 4px solid rgba(255, 255, 255, 0.5);
			flex-shrink: 0;
			margin-right: 100px;
			.box {
				position: relative;
				text-align: left;
				color: #fff;
				padding: 20px 0 20px 20px;
				cursor: pointer;
				&::after {
					content: ' ';
					width: 4px;
					height: 100%;
					margin-top: -20px;
					position: absolute;
					left: -4px;
					background: rgba(255, 255, 255, 0.5);
				}
				&.active {
					color: #18ede5;
					&::after {
						content: ' ';
						width: 4px;
						height: 100%;
						margin-top: -20px;
						position: absolute;
						left: -4px;
						background: #18ede5;
					}
				}
			}
		}
		.side-swiper {
			flex: 1;
			height: 500px;
			.swiper-slide {
				display: flex;
				align-items: center;
			}
			.box {
				border-radius: 6px;
				padding: 40px;
				background: rgba(247, 247, 247, 0.2);
				display: flex;
				flex: 1;
				img {
					width: 360px;
					height: 270px;
					flex-shrink: 0;
				}
				.em {
					flex: 1;
					color: #fff;
					margin-left: 20px;
					.h {
						font-size: 28px;
						padding-bottom: 20px;
						border-bottom: 1px solid #e5e5e5;
					}
					.text {
						padding: 20px 0;
					}
					.btns {
						text-align: right;
						a {
							cursor: pointer;
							color: #18ede5;
						}
					}
				}
			}
			.swiper-container {
				height: 500px;
			}
		}
	}
}
</style>
